import { KalenderArbeitsbereich as ArbeitsbereichType } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import { faDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Arbeitsbereich({
  arbeitsbereich,
}: {
  arbeitsbereich: ArbeitsbereichType;
}) {
  return (
    <div className="sticky left-0 z-10 flex gap-2 items-center border-r border-solid border-neutrals-200 bg-white">
      <FontAwesomeIcon
        className="w-fit"
        size="3x"
        icon={faDot}
        color={arbeitsbereich.getBorderColor()}
      />
      <div className="text-sm text-neutrals-900 truncate">
        {arbeitsbereich.name}
      </div>
    </div>
  );
}
